export class PurchaseOrderItemDto {

    public readonly poNumber: string;
    public readonly distributor: string;
    public readonly quantity: number | null;
    public readonly sku: string | null;
    public readonly name: string | null;
    public readonly brand: string | null;
    public readonly color: string | null;
    public readonly style: string | null;
    public readonly size: string | null;
    public readonly submittedDateTime: string;
    public readonly successDateTime: string | null;
    public readonly failureDateTime: string | null;

    constructor(poNumber: string, distributor: string, quantity: number | null, sku: string | null, name: string | null,
                color: string | null, brand: string | null, style: string | null, size: string | null,
                submittedDateTime: string, successDateTime: string | null, failureDateTime: string | null) {
        this.poNumber = poNumber;
        this.distributor = distributor;
        this.quantity = quantity;
        this.sku = sku;
        this.name = name;
        this.brand = brand;
        this.color = color;
        this.style = style;
        this.size = size;
        this.submittedDateTime = submittedDateTime;
        this.successDateTime = successDateTime;
        this.failureDateTime = failureDateTime;
    }
}
